import React from "react";
import { BIONIVID_LOGO_GREEN, NIVILABS_LOGO } from "@/lib/api";

export function About() {
  return (
    <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="about-page">
      <div className="text-xs tracking-[0.2em] uppercase text-primary font-semibold">About us</div>
      <h1 className="font-display text-4xl sm:text-5xl font-bold mt-2">Bridging Genomics Expertise with Molecular Biology Tools</h1>
      <p className="text-lg text-muted-foreground mt-5 leading-relaxed">
        <b>nivilabs</b> is the product development and manufacturing arm of <b>Bionivid Technology Pvt. Ltd</b>., a Bengaluru-based
        biotechnology pioneer with over a decade of proven expertise in Next-Generation Sequencing (NGS), bioinformatics,
        and advanced life-science services.
      </p>
      <p className="text-lg text-muted-foreground mt-5 leading-relaxed">
        As a premier name in genomics, our journey began in the wet lab. For over ten years, we have successfully tackled
        the most complex challenges in genomics, handling an incredibly diverse array of tissue types for DNA and RNA
        extraction. We know first-hand that breakthrough discoveries rely on the absolute purity and integrity of your
        starting material, and we also know how frustrating it is for biologists to struggle with nucleic acid extraction
        from difficult, recalcitrant samples.
      </p>
      <p className="text-lg text-muted-foreground mt-5 leading-relaxed">
        Driven by this diverse hands-on expertise, we founded nivilabs. We decided to channel our deep scientific rigor into
        developing and curating cutting-edge Nucleic Acid Extraction Kits and molecular biology reagents that researchers can
        actually depend on.
      </p>
      <div className="mt-12 rounded-3xl bg-slate-50 p-8 border border-slate-200">
        <div className="text-base tracking-[0.2em] uppercase text-primary font-semibold">What We Do</div>
        <p className="text-lg text-muted-foreground mt-4 leading-relaxed">
          At nivilabs, we focus on empowering scientists and laboratories worldwide by eliminating procurement guesswork and
          experimental variability. Our core offerings include:
        </p>
        <ul className="mt-6 space-y-4 list-disc list-inside text-lg text-muted-foreground">
          <li>
            <span className="font-semibold">Innovative Extraction Kits:</span> Carefully designed and rigorously tested to ensure
            high-yield, high-purity DNA and RNA extraction even from the most challenging biological tissues.
          </li>
          <li>
            <span className="font-semibold">Molecular Biology Reagents:</span> A comprehensive portfolio of enzymes, kits, and
            master mixes formulated to deliver unmatched consistency.
          </li>
        </ul>
      </div>
      <div className="mt-12 grid md:grid-cols-2 gap-6">
        <div className="p-6 bg-white border border-gray-100 rounded-xl">
          <img src={NIVILABS_LOGO} className="h-16 w-16 object-contain mb-4" alt="nivilabs" />
          <h3 className="font-display font-bold text-xl">nivilabs</h3>
          <p className="text-sm text-muted-foreground mt-2">Solution for laboratory consumables, reagents, enzymes, kits, and research products. Built for Indian research labs and beyond.</p>
        </div>
        <div className="p-6 bg-white border border-gray-100 rounded-xl">
          <img src={BIONIVID_LOGO_GREEN} className="h-16 w-16 object-contain mb-4" alt="Bionivid" />
          <h3 className="font-display font-bold text-xl">Bionivid Technology Pvt. Ltd.</h3>
          <p className="text-sm text-muted-foreground mt-2">A genomics-focused biotech company offering NGS services, bioinformatics, and applied research solutions since 2014.</p>
        </div>
      </div>
    </main>
  );
}

export function Contact() {
  return (
    <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="contact-page">
      <div className="text-xs tracking-[0.2em] uppercase text-primary font-semibold">Get in touch</div>
      <h1 className="font-display text-4xl sm:text-5xl font-bold mt-2">Talk to our scientific team.</h1>
      <p className="text-muted-foreground mt-4 max-w-2xl">For custom inquiries, bulk pricing, or technical support, drop us a note. We typically respond within one business day.</p>
      <div className="mt-10 grid md:grid-cols-3 gap-4">
        <Info label="Email" value="nivilabs@bionivid.com" />
        <Info label="Phone" value="+91 953 5619 191" />
        <Info label="Headquarters" value="3rd Floor, Saanvi Complex, 28, Kattigenahalli, Bengaluru, Karnataka 560064" />
      </div>
      <div className="mt-10 p-6 bg-primary/5 border border-primary/10 rounded-xl">
        <p className="text-sm">To submit a product Request-for-Quote, browse the catalog and add items to your inquiry cart. Our team will contact you within 24 hours.</p>
      </div>
    </main>
  );
}

const Info = ({ label, value }) => (
  <div className="p-5 bg-white border border-gray-100 rounded-xl">
    <div className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground">{label}</div>
    <div className="font-display font-semibold mt-1">{value}</div>
  </div>
);
